<cll-card class="app-form-card" *ngIf="owner">
    <cll-card-header>
        <cll-card-title>
            Fixed Rates
        </cll-card-title>

        <cll-card-header-actions>
            <button cll-outline-button
                    colour="variant"
                    [disabled]="isDisabled"
                    data-testid="button:disabled"
                    (click)="owner.default_rate_strategy = 'fixed'"
                    *ngIf="activeOwner.default_rate_strategy !== 'fixed'"
                    cllTooltip="Click to enable">
                <mat-icon>clear</mat-icon>
                Disabled
            </button>

            <button cll-outline-button
                    colour="variant"
                       [disabled]="isDisabled"
                       data-testid="button:enabled"
                       (click)="owner.default_rate_strategy = 'hourly'"
                       *ngIf="activeOwner.default_rate_strategy !== 'hourly'"
                       cllTooltip="Click to disable">
                <mat-icon>check</mat-icon>
                Enabled
            </button>
        </cll-card-header-actions>
    </cll-card-header>

    <ng-container *ngIf="activeOwner.default_rate_strategy === 'fixed'">
        <app-alert info>
            The system will use the fixed rate assigned to the booking, otherwise using the default
            fixed rate. If there is no fixed rate, hourly rate calculation will be used.
        </app-alert>

        <p class="hint">
            Fixed rates can be used if you want to charge the same amount irrespective of the length of the
            visit. Once added, you can choose whether you want to default to a fixed rate for each booking
            that uses this service contract, or you can choose fixed rates for individual bookings.
        </p>

        <hr class="app-separator">

        <app-fixed-rates [(rates)]="activeOwner.fixed_rates.data"
                         [disabled]="isDisabled"
                         [(default)]="activeOwner.default_fixed_rate_id" />
    </ng-container>
</cll-card>
